export const getArticleType = article => {
  if (article.awardPage) return 'awardPage';
  if (article.newsArticle) return 'newsArticle';
  if (article.eventPage) return 'eventPage';
  if (article.insightArticle) return 'insightArticle';
  if (article.caseStudy) return 'caseStudy';
  return null;
};
